/**
 * Google Translate
 *
 * Exposes exactly one web-accessible resource, so detection is single-signal with no
 * corroboration available. That makes it more brittle than most: if Google renames
 * this one stylesheet, detection silently stops working and there is no fallback.
 *
 * Manifest verified against version 2.0.17.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'aapbdbdomjkkjkaonfhkkikfgjllcleb';

export const googleTranslate: ExtensionDefinition = {
  id: ID,
  name: 'Google Translate',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 29_000_000,
  notes:
    'Only one web-accessible resource exists, so there is a single point of failure — ' +
    'no second signal can corroborate it.',
  signals: [
    {
      id: 'war-popup-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch popup_css_compiled.css — the extension\'s only web-accessible resource, ' +
        'exposed to <all_urls>.',
      weight: 1,
      run: () => probeFetch(ID, 'popup_css_compiled.css'),
    },
  ],
};
